import { render, staticRenderFns } from "./EDrawerMotivoAula.vue?vue&type=template&id=d7cb6452&scoped=true"
import script from "./EDrawerMotivoAula.vue?vue&type=script&lang=js"
export * from "./EDrawerMotivoAula.vue?vue&type=script&lang=js"
import style0 from "./EDrawerMotivoAula.vue?vue&type=style&index=0&id=d7cb6452&prod&setup=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7cb6452",
  null
  
)

export default component.exports